<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/14WpSvY/tc-custom/9781800322530.jpg?1705038287479" alt="This image is the cover for the book Beautiful Star & Other Stories"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Beautiful Star & Other Stories
      </h1>
      <p class="bookDescription body article font2">
        <p><b>Ordinary people are swept up in extraordinary historical events in these gripping short stories by the bestselling author of <i>The King’s Spy</i>.</b><br/>  <br/> History is brought alive by the everyday people whose lives it affects in this moving collection of short fiction. In <i>Beautiful Star &amp; Other Stories</i> we meet Eilmer, a monk in 1010 with Icarus-like dreams; Charles I, in hiding in 1651 and befriended by a small boy; the trial of Jane Wenham, witch of Walkern, seen through the eyes of her granddaughter, among many others.<br/>  <br/> From the author of the Thomas Hill trilogy, this is an affecting journey through the centuries, bringing a new perspective to such events as the defense of Corfe Castle, the battle of Waterloo, the siege of Toulon, and, in the title story, the devastating dangers of the life of the sea in 1875. </p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Andrew Swanston
      </h2>
      
      <p class="authorDescription body article"><P>A. D. Swanston read a little law and a lot of sport at Cambridge University, and held various positions in the book trade, including being a director of Waterstone &amp; Co, and chairman of Methven’s plc, before turning to writing. Inspired by a lifelong interest in early modern history, his Thomas Hill novels are set during the English Civil Wars, and the early period of the Restoration.</P><P>He lives with his wife in Surrey, near to their three children and two grandchildren. His interests include golf, gardening, and drawing.</P></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Canelo Digital Publishing Limited
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?6bbf66c9